export const smallMobile = 370;
